enum BeeswaxMappedDigitalChannel {
  STREAMING = 'Streaming TV',
  DISPLAY = 'Display',
  OLV = 'OLV',
  AUDIO = 'Audio',
  GAMING = 'Gaming',
  OLV_APP_BASED = 'OLV App Based',
}

export default BeeswaxMappedDigitalChannel;
